import _ from 'lodash'

export const showSupportChat = message => {
	if (window.Intercom) {
		window.Intercom('showNewMessage', _.isString(message) && message)
	}
}
